require('./bootstrap');

import Vue from 'vue';
//Rutas del website
import Router from './router.js';

//Librerias globales
import Library from './libs.js';
Vue.use(Library);

//Componentes del website
import components from './components/components.js';
Vue.use(components);

window.Vue=Vue;

//Instancia principal
const app = new Vue({
  el: '#app',
  router:Router,

  data() {
    return {
      socialNetworks: {
        fb: 'https://www.facebook.com/soyviajare',
        ig: 'https://www.instagram.com/soyviajare/',
        yt: 'https://www.youtube.com/@viajareoficial',
      },
    }
  },
});
